import { render } from "./CollectionsComparisonReportPage.vue?vue&type=template&id=25264164&scoped=true"
import script from "./CollectionsComparisonReportPage.vue?vue&type=script&lang=js"
export * from "./CollectionsComparisonReportPage.vue?vue&type=script&lang=js"

import "./CollectionsComparisonReportPage.vue?vue&type=style&index=0&id=25264164&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/fep.theismailiusa.org/srv/ibsreg-test.theismailiusa.org/github-httpdocs/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25264164"]])

export default __exports__